import React from "react";

import nary from "./nary";

import { isPortrait } from "./commonMobile";
import "../components/PopupResultHistoryGameList/index.scss";
import { isIPhone } from "./iOSDetection";

// UI FUNCTIONS
function changePortraitResultHistoryTab(e: any) {
	const tabIndex = e.currentTarget.getAttribute("tab-index");

	this.setState({ portraitTabIndex: Number(tabIndex) });
}

function openResultHistory() {
	//LobbyMobile
	if ("closeNavbarMenu" in this)
		this.closeNavbarMenu();

	if ("showBurgerMenu" in this.state)
		this.setState({ showBurgerMenu: false });

	this.setState({
		showGameResultHistoryPopup: !this.state.showGameResultHistoryPopup,
		showTransactionHistoryPopup: false
	});
}

function openTransactionHistory() {
	//Copied from Lobby
	if (this.allowRefetchTransaction) {
		this.fetchTransactionHistory();
		this.allowRefetchTransaction = false;

		window.setTimeout(lobby => {
			lobby.allowRefetchTransaction = true;
			// console.log("Refetch timeout");
		}, 3000, this);
	}


	//LobbyMobile
	if ("closeNavbarMenu" in this)
		this.closeNavbarMenu();

	if ("showBurgerMenu" in this.state)
		this.setState({ showBurgerMenu: false });

	this.setState({
		showGameResultHistoryPopup: false,
		showTransactionHistoryPopup: !this.state.showTransactionHistoryPopup
	});
}



// COMMON FUNCTIONS
//Get Ace & Ten Card Value
function getATValue(str: string): number {
	const newStr = str.replace("A", "1").replace("T", "10");

	if (isNaN(+newStr[0])) return 0;
	return parseInt(newStr, 10);
}

function reduceSumArray(now: string, next: string): number {
	const replaceAT = (str: string) => str.replace("A", "1").replace("T", "10");
	const valNow = !now ? 0 : isNaN(+replaceAT(now)[0]) ? 0 : (parseInt(replaceAT(now), 10));
	const valNext = !next ? 0 : isNaN(+replaceAT(next)[0]) ? 0 : (parseInt(replaceAT(next), 10));
	return (+valNow + +valNext) % 10;
}

/**
 * 
 * @param {string[]} cards The card array to check.
 */
function checkBaccaratPairExists(cards: string[]) {
	return cards[0][0] === cards[1][0];
}

function checkDoesPairExists(cards: string[]) { //cards: String[3]
	const cardsCopy = cards.slice(0).map(item => item[0]);

	const sortedArray = cardsCopy.slice().sort();

	const results = [];
	for (let i = 0; i < sortedArray.length - 1; i++) {
		if (sortedArray[i + 1] === sortedArray[i]) {
			results.push(sortedArray[i]);
		}
	}

	// console.log(results);
	return results.length > 0;
}

interface IParamObject {
	portraitTabIndex: number;
	showGameResultHistoryLoadingOverlay: boolean;
	tabNames: string[];

	mobile?: boolean;
	mobileHome?: boolean;
	desktop?: boolean;
	orientation?: string;
}

//RESULT HISTORY
function renderResultHistory(resultHistoryObject,
	basePcode: string,
	headers: string[],
	bodyMapFunction: (arg0: any, arg1: number) => void,
	gameResultHistoryPage: number,
	fetchResultHistory: (e: any) => void,
	_changePortraitResultHistoryTab: (e: any) => void,
	paramObject: IParamObject,
	showDetail: boolean = false,
	indexDetail: number = 0,
	backFromDetail: (e: any) => void = null) {
	const panelClassName = "side-result-history-panel" +
		(paramObject.mobile ? " sl-single-mobile" : "") +
		(paramObject.mobileHome ? " mobile-home" : "") +
		(paramObject.desktop ? " desktop" : "") +
		(" " + paramObject.orientation) +
		(isIPhone() ? " iphone" : "") +
		(showDetail ? " history-detail" : "");

	if (!resultHistoryObject || !resultHistoryObject.history)
		return (
			<div className={panelClassName}>
				<br />
				There is no data available.
			</div>
		);

	if (showDetail && !Array.isArray(resultHistoryObject.history[indexDetail].details))
		return (
			<div className={panelClassName}>
				<br />
				<button className="btn-detail" onClick={backFromDetail}>Back</button>
				<br /><br />
				Something when wrong in type data details
			</div>
		)

	return (
		<div key="PRH history panel" className={panelClassName}>
			{
				showDetail ?
					<button className="btn-detail btn-back" onClick={backFromDetail}>Back</button> : null
			}

			{
				resultHistoryObject.history &&
					resultHistoryObject.history.length === 0 ?
					<div>"Empty history."</div> : ""
			}

			{
				//paramObject.portraitTabIndex
				paramObject.orientation === "portrait" ?
					<div className="tab-container">
						{
							(paramObject.tabNames || ["0", "1", "2"]).map((item, idx) =>
								<div key={"srhp_tc_" + item}
									className={paramObject.portraitTabIndex === idx ? "active" : ""}
									onClick={_changePortraitResultHistoryTab} tab-index={idx}>
									{item}
								</div>
							)
						}
					</div>
					: null
			}

			<table key="rRH_table" className="result-history-table">
				<thead>
					<tr className="row-header">
						{
							headers.map((item, idx) => {
								if (basePcode === "m23" || basePcode === "m22" || basePcode === "m38") {
									return (
										<th key={`rRH_table_${idx}`} className={idx === 2 ? "header-result-history-win" : ""}>{item}</th>
									)
								} else {
									return (
										<th key={`rRH_table_${idx}`}>{item}</th>
									)
								}
							}
							)
						}
					</tr>
				</thead>

				{
					showDetail ?
						resultHistoryObject.history[indexDetail].details.map(bodyMapFunction) :
						<tbody>
							{resultHistoryObject.history.map(bodyMapFunction)}
						</tbody>
				}
			</table>

			{ !showDetail && <Pagination
				currentPage={gameResultHistoryPage}
				splitSize={10}
				//Basic onClick function -- to be used on changing pages
				changePage={fetchResultHistory}
				totalItems={Number(resultHistoryObject.totalHistory)} />}

			{
				paramObject.showGameResultHistoryLoadingOverlay ?
					<div className="game-result-history-overlay">
						Loading...
				</div> : null
			}
		</div>
	);
}

function Pagination(props: { currentPage: number; splitSize: number; changePage: React.MouseEventHandler; totalItems: number; }) {
	const currentPage = Number(props.currentPage),
		splitSize = props.splitSize,
		changePage = props.changePage;
	const totalPages = Math.ceil(props.totalItems / splitSize); //15

	// console.log("P tP", totalPages);

	const paginationPages = isPortrait() ? 8 : 10;

	const firstPage = (Math.ceil(currentPage / paginationPages) - 1) * paginationPages;

	return (
		<ul className="pagination">
			<li className={currentPage === 1 ? "disabled" : ""}>
				{
					currentPage === 1 ? (
						<span>First</span>
					) : (
						<div className="link"
							{...{ page: 1 }}
							onClick={changePage}>
							First
						</div>
					)
				}
			</li>

			<li className={currentPage < paginationPages ? "disabled" : ""}>
				{
					currentPage < paginationPages ? (
						<span>Prev.</span>
					) : (
						<div className="link"
							{...{ page: currentPage - paginationPages }}
							onClick={changePage}>
							Prev.
						</div>
					)
				}
			</li>

			{
				//todo: use nary
				nary(paginationPages).map(num =>
					firstPage + num > totalPages ? null :
						currentPage === firstPage + num ?
							(
								<li key={"rWD cP" + (firstPage + num)} className="active">
									<span>{currentPage}</span>
								</li>
							) : (
								<li key={"rWD" + (firstPage + num)}>
									<div className="link"
										{...{ page: firstPage + num }}
										onClick={changePage}>
										{firstPage + num}
									</div>
								</li>
							)
				)
			}

			<li className={currentPage >= totalPages - paginationPages ? "disabled" : ""}>
				{
					currentPage >= totalPages - paginationPages ? (
						<span>Next</span>
					) : (
						<div className="link"
							{...{ page: currentPage + paginationPages }}
							onClick={changePage}>
							Next
						</div>
					)
				}
			</li>

			<li className={currentPage === totalPages ? "disabled" : ""}>
				{
					currentPage === totalPages ? (
						<span>Last</span>
					) : (
						<div className="link"
							{...{ page: totalPages }}
							onClick={changePage}>
							Last
						</div>
					)
				}
			</li>
		</ul>
	);
}

export {
	changePortraitResultHistoryTab,
	openResultHistory,
	openTransactionHistory,

	getATValue,
	reduceSumArray,
	checkBaccaratPairExists,
	checkDoesPairExists,
	renderResultHistory,

	Pagination
};